import { render, staticRenderFns } from "./ApproveLogoButton.vue?vue&type=template&id=057ba027"
import script from "./ApproveLogoButton.vue?vue&type=script&lang=ts"
export * from "./ApproveLogoButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports